import { isValid, parse } from 'date-fns';
import { zonedTimeToUtc } from 'date-fns-tz';

export function getDateFromTimeString(date: Date, timeString: string, timeZone?: string): Date {
  let newDate: Date;
  if (/:..:/.test(timeString)) {
    newDate = parse(timeString, 'HH:mm:ss', date);
  } else {
    newDate = parse(timeString, 'HH:mm', date);
  }
  if (!isValid(newDate)) {
    throw new Error(`Failed to parse '${timeString}' into a time.`);
  }
  if (timeZone) {
    return zonedTimeToUtc(newDate, timeZone);
  }
  return newDate;
}
